module.exports = __webpack_public_path__ + "img/project_bg.8dab43d7.jpg";